// Local Imports
import { LongArrow } from "../../../assets/icons";

export const RedirectLink = ({
  text,
  onClick,
  noArrow,
  sx,
  textClassName,
  iconClassName,
}) => {
  return (
    <button
      type="button"
      className={`vertical-center inline-flex gap-2 text-sm text-secondary-dark group cursor-pointer ${sx}`}
      onClick={onClick}
    >
      <p className={`font-sans font-bold ${textClassName}`}>{text}</p>
      {noArrow ? (
        ""
      ) : (
        <LongArrow
          className={`group-hover:!translate-x-1 transition fill-white current ${iconClassName}`}
        />
      )}
    </button>
  );
};

export default RedirectLink;
